
<div class="modal-dialog search-help-dialog">
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title">Search Help</h4>
      <button class="close" type="button" (click)="close()">&times;</button>
    </div>
    <div class="modal-body">
      <div class="row">
        <div class="col-xl-5">
          <div class="row">
            <div class="col-12">
              <h4>Syntax</h4>
              <p>Any combination of these options can be used</p>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-6">
              <ul class="search-syntax-list">
                <li>Search for some text:
                  <div class="d-flex p-1">HPI</div>
                  <div class="d-flex p-1 search-example">"HP Inc."</div>
                </li>
                <li>Search for something particular
                  <div class="d-flex p-1">name:John</div>
                  <div class="d-flex p-1">name:"John Doe"</div>
                </li>
              </ul>
            </div>
            <div class="col-sm-6">
              <ul class="search-syntax-list">
                <li>Search with multiple restrictions:
                  <div class="d-flex p-1">HPI name:John</div>
                </li>
                <li>Exclude search results:
                  <div class="d-flex p-1">-HP</div>
                  <div class="d-flex p-1">-name:John</div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-xl-7">
          <div class="row">
            <div class="col-12">
              <h4>Examples</h4>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-4 mb-1">
              <ul class="list-group">
                <li class="list-group-item" *ngFor="let option of searchOptions; index as i" [ngClass]="{'active': activeIndex === i}" (click)="setActive(i)">{{option.property}}</li>
              </ul>
            </div>
            <div class="col-sm-8">
              <div class="input-group search-box-example" *ngFor="let example of activeOption.examples">
                <input class="form-control" [value]="example" placeholder="Search"><span class="input-group-append">
                  <button class="btn btn-primary">Go</button></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-outline-secondary" type="button" (click)="close()">OK</button>
    </div>
  </div>
</div>